// extracted by mini-css-extract-plugin
module.exports = {"table":"LoanProfileBorrowerInformation_table__23AUC"};